import { render, staticRenderFns } from "./survey-page.vue?vue&type=template&id=198e6486&scoped=true&"
import script from "./survey-page.vue?vue&type=script&lang=js&"
export * from "./survey-page.vue?vue&type=script&lang=js&"
import style0 from "./survey-page.vue?vue&type=style&index=0&id=198e6486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198e6486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('198e6486')) {
      api.createRecord('198e6486', component.options)
    } else {
      api.reload('198e6486', component.options)
    }
    module.hot.accept("./survey-page.vue?vue&type=template&id=198e6486&scoped=true&", function () {
      api.rerender('198e6486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/surveys/survey-page.vue"
export default component.exports